import React from "react";
import styled from "styled-components";

export interface ProductFilterProps {
  insurance_types: string[];
  selected_type: string | null;
  onSelectType: (type: string | null) => void;
  all_label?: string;
}

const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  height: 32px;
  width: max-content;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

const Divider = styled.div`
  width: 1px;
  height: 32px;
  background: #d9dbde;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
`;

const ChipsGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  height: 32px;
  flex: none;
  flex-grow: 0;
`;

const ChipButton = styled.button<{ $selected: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  gap: 8px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  border: ${(props) =>
    props.$selected ? "1px solid #435DFF" : "1px solid #D9DBDE"};
  background: ${(props) => (props.$selected ? "#435DFF" : "#FFFFFF")};
  color: ${(props) => (props.$selected ? "#FFFFFF" : "#202123")};
  flex: none;
  flex-grow: 0;

  &:hover {
    background: ${(props) => (props.$selected ? "#304eff" : "#F5F6F7")};
    border-color: ${(props) => (props.$selected ? "#304eff" : "#C8CACD")};
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: none;
`;

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 4L6 11.3333L2.66667 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const val: any = () => null;
val.isRequired = () => null;

export const ProductFilter = ({
  insurance_types,
  selected_type,
  onSelectType,
  all_label = "All",
}: ProductFilterProps) => {
  return (
    <FilterContainer>
      <ChipButton
        $selected={selected_type === null}
        onClick={() => onSelectType(null)}
      >
        {selected_type === null && (
          <IconWrapper>
            <CheckIcon />
          </IconWrapper>
        )}
        {all_label}
      </ChipButton>

      {insurance_types.length > 0 && <Divider />}

      {insurance_types.length > 0 && (
        <ChipsGroup>
          {insurance_types.map((type) => {
            const isSelected = selected_type === type;
            return (
              <ChipButton
                key={type}
                $selected={isSelected}
                onClick={() => onSelectType(type)}
              >
                {isSelected && (
                  <IconWrapper>
                    <CheckIcon />
                  </IconWrapper>
                )}
                {type}
              </ChipButton>
            );
          })}
        </ChipsGroup>
      )}
    </FilterContainer>
  );
};

ProductFilter.propTypes = {
  insurance_types: val.isRequired,
  selected_type: val,
  onSelectType: val.isRequired,
  all_label: val,
};

ProductFilter.defaultProps = {
  selected_type: null,
  all_label: "All",
};

export default ProductFilter;
